import React from 'react';
import ChallengesInReview from '../components/challenges/ChallengesInReview';

export const ReviewChallengesPage: React.FC = () => {
  return <ChallengesInReview />;
};
